import Vue from 'vue'
import Router from 'vue-router'
import Toast from 'muse-ui-toast'
import _ from 'lodash'

import routes from './routes'
import { userStore } from '@/store/user'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
})

export const keepAlivePages = ['MoAccountPage']

// when landing page not '/', router.back() may be a trouble
router._numRouteVistied = -1
router.safeBack = function() {
  if (router._numRouteVistied < 1) {
    router.replace('/')
  } else {
    router.back()
  }
}

router.beforeEach((to, from, next) => {
  // after some path visited, browser history can go back safely
  if (router._numRouteVistied < 1) {
    router._numRouteVistied += 1
  }
  const loginRequired = to.matched.some(record => record.meta.loginRequired)
  const goLogin = error => {
    let response = error.response
    // When "Network Error", not redirect to login
    // https://github.com/axios/axios/issues/383
    if (_.isNil(response) && _.isNil(error.status)) {
      return goNext()
    }
    if (response && response.status >= 500) {
      Toast.error(error.message)
      return next(false)
    }
    userStore.setLoginReturnTo(from.fullPath)
    next({
      path: userStore.getAuthPath(),
      replace: true,
    })
  }
  const goNext = () => next()
  if (loginRequired) {
    userStore
      .login()
      .then(goNext)
      .catch(goLogin)
  } else {
    userStore
      .login()
      .then(() => {
        const isAuthPage = to.name === 'Login' || to.name === 'Register'
        if (isAuthPage) {
          next({
            path: '/',
            replace: true,
          })
        } else {
          goNext()
        }
      })
      .catch(goNext)
  }
})

export default router
